import React from 'react';

const ImageHeader = () => {
  return (
    <div>
      <img src="./images/header.jpg" alt="kitchen with windows" width="100%" height="auto" display="flex"></img>
    </div>
  )
}

export default ImageHeader